export default [
	'Auto',
	'Auto Parts',
	'Bank',
	'Big Box',
	'Car Wash',
	'Cellular Store',
	'Coffee',
	'Day Care/School',
	'Department Store',
	'Dollar Store',
	'Drug Store',
	'Dry Cleaner',
	'Entertainment',
	'Fast Food',
	'Fitness',
	'Gas/Convenience Store',
	'Grocery',
	'Home Improvement',
	'Liquor',
	'Mattress Store',
	'Medical',
	'Office Supply',
	'Other',
	'Pawn Shop',
	'Restaurant',
	'Tractor Supply',
	'Video Store',
];